(function ($, document, Drupal) {
  // Snowflake Animation Canvas Setup
  var $canvas;
  var sfContext;
  var totalNoOfFlakes = 0;
  var flakes = [];
  var offScreenCanvasElement;
  var offScreenCanvasElementContext;
  var stopGameFor24Hrs;
  var animateSnowFlakesTimer;
  var $window = $(window);

  Drupal.behaviors.randomizerV1 = {
    attached: false,
    isMobile: false,
    unisonDependent: true,
    unisonReady: false,
    options: {
      defaultCustomImageExtension: 'png',
      productCustomImageExtension: 'jpg',
      productImageSize: 'IMAGE_LARGE'
    },

    attach: function (context) {
      var self = this;
      if (self.attached) {
        return;
      }
      // if Unison is not ready on attach, it triggers change on initialization
      if (!!Unison.fetch.now()) {
        self.unisonReady = true;
      }

      Unison.on('change', function () {
        if (!self.attached && self.unisonDependent) {
          // re attach on unisonReady, the initial attach was return
          self.attach(context);
        }
      });

      if (!self.unisonReady && self.unisonDependent) {
        return;
      }
      self.attached = true;

      self.element = context.querySelector('.js-game-formatter-v1');
      self.$element = $(self.element);
      self.gameFormatter = Drupal.behaviors.gameFormatterV1;

      self.updateCurrentViewportinfo();
      self.setElements();
      self.setEvents();

      $canvas = $('#sfCanvas', context)[0];
      sfContext = $canvas.getContext('2d');

      offScreenCanvasElement = document.createElement('canvas');
      offScreenCanvasElementContext = offScreenCanvasElement.getContext('2d');

      var noOfFlakesSml = self.$snowflakeCanvas.data('animated-items-sml') || 25;
      var noOfFlakesMed = self.$snowflakeCanvas.data('animated-items-med') || 10;
      var noOfFlakesLrg = self.$snowflakeCanvas.data('animated-items-lrg') || 5;
      var currentViewport;
      var headerHeight = $('#page-header-wrapper', context).height();
      var windowHeight;
      var maxTriesAvailable = self.$element.attr('data-maximum-tries') || 0;
      var currentChanceImageAvailable = self.$gameChancesImage.length || 0;
      var pcGameContainerHeight = self.$gameContainer.attr('data-pc-game-container-height');
      var mobileGameContainerHeight = self.$gameContainer.attr('data-mobile-game-container-height');

      stopGameFor24Hrs =
        parseInt(self.$gameContainer.attr('data-stop-game-twenty-four-hours'), 10) || 0;
      var foreGroundFlakesFallSpeed = parseFloat(
        self.$snowflakeCanvas.attr('data-flakes-fall-speed-factor')
      );
      var flakesRotateSpeed = parseFloat(
        self.$snowflakeCanvas.attr('data-flakes-rotate-speed-factor')
      );

      for (var i = 0, j = maxTriesAvailable - currentChanceImageAvailable; i < j; i++) {
        self.$gameChancesImage.eq(0).clone().appendTo(self.$gameChancesImageContainer);
      }

      var backGroundAnimFlakesImage = self.$snowflakeCanvas.attr('data-pc-anim-image-background');
      var backGroundAnimFlakesImageMobile = self.$snowflakeCanvas.attr(
        'data-mobile-anim-image-background'
      );
      var middleLayerAnimFlakesImage = self.$snowflakeCanvas.attr(
        'data-pc-anim-image-middle-layer'
      );
      var middleLayerAnimFlakesImageMobile = self.$snowflakeCanvas.attr(
        'data-mobile-anim-image-middle-layer'
      );
      var foreGroundAnimFlakesImage = self.$snowflakeCanvas.attr('data-pc-anim-image-foreground');
      var foreGroundAnimFlakesImageMobile = self.$snowflakeCanvas.attr(
        'data-mobile-anim-image-foreground'
      );

      var updateGameContainerHeight = function () {
        if (pcGameContainerHeight && mobileGameContainerHeight) {
          windowHeight = $window.height();
          var containerHeightFromCMS = self.isMobile
            ? mobileGameContainerHeight
            : pcGameContainerHeight;
          self.$gameContainer.height(parseInt(containerHeightFromCMS, 10));
        }
      };

      updateGameContainerHeight();

      var buildAnimationFlakeItems = function (flakeImagedata) {
        if (flakeImagedata) {
          var flakeImagesArray = flakeImagedata.split('^===^');

          if (flakeImagesArray.length) {
            $.each(flakeImagesArray, function (index, data) {
              var eachFlakeData = data.split('|');
              var obj = {
                flakeImage: eachFlakeData[0] ? eachFlakeData[0].split(':')[1] : false,
                noOfFlakes: eachFlakeData[1] ? parseInt(eachFlakeData[1].split(':')[1], 10) : 1,
                flakesFallSpeed: foreGroundFlakesFallSpeed,
                flakesRotateSpeed: flakesRotateSpeed,
                doNotAllowFlakesToFall: eachFlakeData[2]
                  ? parseInt(eachFlakeData[2].split(':')[1], 10)
                  : 0,
                overrideXCoordinateInPercentage: eachFlakeData[3]
                  ? parseInt(eachFlakeData[3].split(':')[1], 10)
                  : null,
                overrideYCoordinateInPercentage: eachFlakeData[4]
                  ? parseInt(eachFlakeData[4].split(':')[1], 10)
                  : null,
                overrideSizeFactor: eachFlakeData[5]
                  ? parseFloat(eachFlakeData[5].split(':')[1])
                  : null
              };

              if (obj.flakeImage && obj.noOfFlakes) {
                self.loadFlakes(obj);
              }
            });
          }
        }
      };
      var buildCanvas = function () {
        flakes = [];
        $canvas.width = window.innerWidth;
        $canvas.height = $('.js-game-play', context).height();

        if (self.$snowflakeCanvas.data('anim-image-sml')) {
          var objSmlImage = {
            flakeImage: self.$snowflakeCanvas.data('anim-image-sml'),
            noOfFlakes: noOfFlakesSml,
            flakesFallSpeed: foreGroundFlakesFallSpeed,
            flakesRotateSpeed: flakesRotateSpeed,
            doNotAllowFlakesToFall: 0,
            overrideXCoordinateInPercentage: null,
            overrideYCoordinateInPercentage: null,
            overrideSizeFactor: null
          };

          self.loadFlakes(objSmlImage);
        }
        if (self.$snowflakeCanvas.data('anim-image-med')) {
          var objMedImage = {
            flakeImage: self.$snowflakeCanvas.data('anim-image-med'),
            noOfFlakes: noOfFlakesMed,
            flakesFallSpeed: foreGroundFlakesFallSpeed,
            flakesRotateSpeed: flakesRotateSpeed,
            doNotAllowFlakesToFall: 0,
            overrideXCoordinateInPercentage: null,
            overrideYCoordinateInPercentage: null,
            overrideSizeFactor: null
          };

          self.loadFlakes(objMedImage);
        }
        if (self.$snowflakeCanvas.data('anim-image-lrg')) {
          var objLrgImage = {
            flakeImage: self.$snowflakeCanvas.data('anim-image-lrg'),
            noOfFlakes: noOfFlakesLrg,
            flakesFallSpeed: foreGroundFlakesFallSpeed,
            flakesRotateSpeed: flakesRotateSpeed,
            doNotAllowFlakesToFall: 0,
            overrideXCoordinateInPercentage: null,
            overrideYCoordinateInPercentage: null,
            overrideSizeFactor: null
          };

          self.loadFlakes(objLrgImage);
        }

        // Build animation flakes for background animation flakes
        buildAnimationFlakeItems(
          !self.isMobile ? backGroundAnimFlakesImage : backGroundAnimFlakesImageMobile
        );
        // Build animation flakes for middle layer animation flakes
        buildAnimationFlakeItems(
          !self.isMobile ? middleLayerAnimFlakesImage : middleLayerAnimFlakesImageMobile
        );
        // Build animation flakes for foreground animation flakes
        buildAnimationFlakeItems(
          !self.isMobile ? foreGroundAnimFlakesImage : foreGroundAnimFlakesImageMobile
        );
      };

      buildCanvas.apply(self);

      /**
       * Set 24 hour cookie once won
       *
       * @returns {boolean} false
       */
      self.set24HourCookie = function () {
        var date = new Date();
        var hours = 24;

        date.setTime(date.getTime() + (hours * 60 * 60 + 1) * 1000);
        document.cookie = 'game_formatter_twenty_four=1;expires=' + date.toUTCString() + ';';
      };

      /**
       * Get 24 hour cookie
       *
       * @returns {boolean} false - if cookie 'game_formatter_twenty_four' is not available
       * @returns {boolean} true - if cookie 'game_formatter_twenty_four' is available
       */
      self.has24HourCookie = function () {
        if ($.cookie('game_formatter_twenty_four')) {
          return 1;
        }

        return 0;
      };

      /**
       * Game init
       *
       * @param {object} data - function to execute once game init has finished which has object parameters
       * @param {object} options - settings options provided to game formatter template js
       * @returns {boolean} false
       */
      self.gameFormatter.init(
        function (data) {
          self.offerCodes = data.offerCodes;
          self.maximumTries = data.maximumTries;
          if (!self.offerCodes.length) {
            // If no offers available then exit
            return false;
          }
          self.$landingPlayBtnContainer.removeClass(
            'game-content__landing-buttons-container--loading'
          );
          if (
            $.cookie('game_formatter_offer_redeemed') ||
            $.cookie('game_formatter_winning_offer')
          ) {
            if (
              self.has24HourCookie() &&
              $.cookie('game_formatter_offer_redeemed') &&
              parseInt(self.gameFormatter.getNumberOfTries(), 10) >= self.maximumTries &&
              stopGameFor24Hrs
            ) {
              // If game will stop for 24hrs, then show 24h popup
              self.$landingPage.addClass('hidden');
              self.$gameTwentyFourHourBox.removeClass('hidden');
            } else {
              // Show win popup
              self.showWinBox(self.gameFormatter.getWinningOffer());
              self.animateSnowflakes();
              self.$turns.removeClass('hidden');
            }
          }
        }.bind(self),
        self.options
      );

      // On window resize, re-draw flakes on canvas
      $window.on(
        'resize',
        _.debounce(function () {
          self.updateCurrentViewportinfo();
          updateGameContainerHeight();
          if (animateSnowFlakesTimer) {
            window.clearTimeout(animateSnowFlakesTimer);
          }
          totalNoOfFlakes = 0;
          buildCanvas.apply(self);
          self.animateSnowflakes();
        }, 250)
      );
    },

    setElements: function () {
      var self = this;

      self.$gameWrapper = $('.js-game-randomizer-v1', self.$element);
      self.$gameContainer = $('.js-game-container', self.$gameWrapper);
      self.$gameChancesImageContainer = $(
        '.js-game-content-chances-image-container',
        self.$gameWrapper
      );
      self.$gameChancesImage = $('.js-game-content-chances-image', self.$gameChancesImageContainer);
      self.$snowflakeCanvas = $('#sfCanvas', self.$element);
      self.$gamePlayBtn = $('.js-button--play', self.$element);
      self.$gameWinBox = $('.js-game-overlay--prize', self.$element);
      self.$gameLoseBox = $('.js-game-overlay--lose', self.$element);
      self.$gameTwentyFourHourBox = $('.js-game-overlay-twenty-four-hour', self.$element);
      self.$playAgainBtnWin = $('.js-game-win-box__try-again-btn', self.$element);
      self.$playAgainBtnLose = $('.js-game-lose-box__try-again-btn', self.$element);
      self.$applyOfferBtn = $('.js-game-win-box__apply-offer', self.$element);
      self.$landingPage = $('.js-game-content--landing', self.$element);
      self.$playPage = $('.js-game-play', self.$element);
      self.$landingPlayBtn = $('.js-button--go', self.$element);
      self.$landingPlayBtnContainer = $('.js-landing-buttons-container', self.$element);
      self.$tcsLink = $('.js-game-terms', self.$element);
      self.$shopNowUrl = $('.js-shop-now-urls', self.$element);
      self.$turns = $('.js-game-turns', self.$element);
      self.$tries = $('.js-game-turns__remaining', self.$element);
      self.$triesContainer = $('.js-game-turns__list', self.$element);
      self.$gameFooter = $('.js-game-footer', self.$element);
      self.$gameLandingContent = $('.js-game-landing-content', self.$landingPage);
    },

    setEvents: function () {
      var self = this;

      self.$landingPlayBtn.on(
        'click',
        function () {
          self.$landingPage.addClass('hidden');
          self.$playPage.removeClass('hidden');
          self.$turns.removeClass('hidden');
          self.populateTriesIndicator(self.$triesContainer);
          self.animateSnowflakes();
        }.bind(self)
      );

      self.$applyOfferBtn.on(
        'click',
        function (event) {
          event.preventDefault();
          self.gameFormatter.applyOffer(self.shopNowRedirect());
        }.bind(self)
      );

      self.$snowflakeCanvas.on(
        'click',
        function (event) {
          event.preventDefault();
          if (self.setTurnsRemaining() > 0) {
            self.playGame();
          }
        }.bind(self)
      );

      self.$playAgainBtnWin.on(
        'click',
        function (event) {
          event.preventDefault();
          self.$playPage.removeClass('hidden');
          self.$gameWinBox.addClass('hidden');
          self.$gameFooter.removeClass('hidden');
          self.populateTriesIndicator(self.$triesContainer);
        }.bind(self)
      );

      self.$playAgainBtnLose.on(
        'click',
        function (event) {
          event.preventDefault();
          self.scrollToHeader();
          self.$gameLoseBox.addClass('hidden');
          self.$playPage.removeClass('hidden');
          self.$gameFooter.removeClass('hidden');
          self.populateTriesIndicator(self.$triesContainer);
        }.bind(self)
      );
    },

    // Load snowflake images and locations for animation
    loadFlakes: function (obj) {
      for (var i = 0; i < obj.noOfFlakes; i++) {
        var x =
          obj.overrideXCoordinateInPercentage !== null
            ? (obj.overrideXCoordinateInPercentage / 100) * $canvas.width
            : ($canvas.width / obj.noOfFlakes) * i;
        var y =
          obj.overrideYCoordinateInPercentage !== null
            ? (obj.overrideYCoordinateInPercentage / 100) * $canvas.height
            : Math.random() * $canvas.height;
        var ys = Math.random() + (parseInt(obj.flakesFallSpeed, 10) || 1);
        flakes.push(
          new Drupal.behaviors.randomizerV1.Flake(
            x,
            y,
            ys,
            obj.flakeImage,
            obj.flakesRotateSpeed,
            obj.doNotAllowFlakesToFall,
            obj.overrideSizeFactor
          )
        );
      }
      totalNoOfFlakes += obj.noOfFlakes;
    },

    Flake: function (
      x,
      y,
      ys,
      flakeImage,
      flakesRotateSpeed,
      doNotAllowFlakesToFall,
      overrideSizeFactor
    ) {
      var self = this;

      self.x = x;
      self.y = y;
      self.ys = ys;
      self.counter = 0;
      self.doNotAllowFlakesToFall = doNotAllowFlakesToFall;
      self.overrideSizeFactor = overrideSizeFactor;

      self.fall = function () {
        if (!self.doNotAllowFlakesToFall) {
          // downward fall
          self.y += self.ys;
          // Reset flakes to top of canvas
          if (self.y > $canvas.height) {
            self.y = -200;
          }
        }
      };

      var img = new Image();

      img.src = flakeImage;
      var resizeFactor = self.overrideSizeFactor
        ? parseFloat(self.overrideSizeFactor).toPrecision(1)
        : parseFloat((Math.random() * (1 - 0.4) + 0.4).toPrecision(1));
      var imageWidth;
      var imageHeight;
      var flakesRotateSpeedFactor = parseFloat(flakesRotateSpeed) || 0;

      self.show = function () {
        var newImageWidth;
        var newImageHeight;

        imageWidth = img.width;
        imageHeight = img.height;
        // scale animated images for smaller screens
        if (self.isMobile) {
          imageWidth = img.width * 0.4;
          imageHeight = img.height * 0.4;
        }

        newImageWidth = imageWidth * resizeFactor;
        newImageHeight = imageHeight * resizeFactor;

        var size = Math.max(img.width, img.height);

        if (flakesRotateSpeedFactor > 0) {
          offScreenCanvasElementContext.clearRect(
            0,
            0,
            offScreenCanvasElement.width,
            offScreenCanvasElement.height
          );
          offScreenCanvasElement.width = size + 2;
          offScreenCanvasElement.height = size + 2;
          offScreenCanvasElementContext.translate(img.width / 2, img.height / 2);
          self.counter += flakesRotateSpeedFactor;
          offScreenCanvasElementContext.rotate((self.counter * Math.PI) / 180);
          offScreenCanvasElementContext.translate(-img.width / 2, -img.height / 2);
          offScreenCanvasElementContext.drawImage(img, 0, 0, img.width, img.height);
          sfContext.drawImage(
            offScreenCanvasElement,
            self.x,
            self.y,
            newImageWidth,
            newImageHeight
          );
          if (self.counter > 360) {
            self.counter = 0;
          }
        } else {
          sfContext.drawImage(img, self.x, self.y, newImageWidth, newImageHeight);
        }
      };
    },

    updateCurrentViewportinfo: function () {
      var self = this;
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPlargeUp = parseInt(Unison.fetch.all()['usn-medium'], 10);
      self.isMobile = currentBpWidth <= bPlargeUp;
    },

    // Run snowflake animation
    animateSnowflakes: function () {
      sfContext.clearRect(0, 0, $canvas.width, $canvas.height);
      for (var i = 0; i < totalNoOfFlakes; i++) {
        flakes[i].show();
        flakes[i].fall();
      }

      animateSnowFlakesTimer = setTimeout(function () {
        window.requestAnimationFrame(Drupal.behaviors.randomizerV1.animateSnowflakes);
      }, 50);
    },

    playGame: function () {
      this.showResult();
    },

    /* Scrolls the screen to show the whole game */
    scrollToHeader: function () {
      var self = this;

      var scrollHeight =
        $('.js-game-mainline', self.$element).height() +
        $('.js-game-landing-title', self.$element).height();
      var targetOffset = Math.min(screen.width / 2.25, scrollHeight);
      var currentOffset = $window.scrollTop();

      if (currentOffset !== targetOffset) {
        $('html, body').animate({
          scrollTop: targetOffset
        });
      }
    },

    showResult: function () {
      var self = this;
      var win = self.gameFormatter.getWinOrLose(true);

      self.$gamePlayBtn.removeClass('disabled');
      self.$playPage.addClass('hidden');
      if (win === true) {
        var winFields = self.gameFormatter.getWinningOffer();

        self.showWinBox(winFields);
        if (stopGameFor24Hrs) {
          self.set24HourCookie();
        }
      } else {
        self.showLoseBox();
      }
    },

    showLoseBox: function () {
      var self = this;
      var $triesContainer = $('.js-game-overlay__lose-remaining-tries', self.$element);

      self.$gameLoseBox.removeClass('hidden');
      if (!self.isMobile) {
        self.$gameFooter.addClass('hidden');
      }
      self.$playPage.addClass('hidden');
      self.populateTriesIndicator($triesContainer);
    },

    /**
     * Shows the Win Box
     * @param {Object} $fields - fields used to populate the win box
     * @returns {bool} false
     */
    showWinBox: function ($fields) {
      var self = this;

      // If there is no param this will not work
      if (!$fields) {
        return false;
      }

      var $winOfferMsg = $('.js-game-overlay__win-offer-message', self.$gameWinBox);
      var $winOfferDescription = $('.js-game-overlay__win-offer-description', self.$gameWinBox);
      var $winBoxImg = $('.js-game-overlay__win-box-image', self.$gameWinBox);
      var $triesContainer = $('.js-game-overlay__win-remaining-tries', self.$element);
      var $winBtnTxt = $('.js-game-overlay__win-btns-txt', self.$element);

      // Fade in the box
      self.$landingPage.addClass('hidden');
      self.$gameWinBox.removeClass('hidden');
      if (!self.isMobile) {
        self.$gameFooter.addClass('hidden');
      }
      self.populateTriesIndicator($triesContainer);

      // Set the win box that the game will use
      $winOfferMsg.html($fields.winningOffer.confirm_message);
      $winOfferDescription.html($fields.description);
      $winBoxImg.css(
        'background-image',
        'url(' +
          self.$element.attr('data-cms-assets-path') +
          $fields.winningOffer.offer_code +
          '.' +
          self.options.defaultCustomImageExtension +
          ')'
      );
      $('html, body').animate({ scrollTop: 0 });
      if (self.setTurnsRemaining() <= 0) {
        self.$playAgainBtnWin.hide();
        $winBtnTxt.hide();
        self.$applyOfferBtn.addClass('mtop');
      }
    },

    shopNowRedirect: function () {
      var self = this;

      var shopNowUrls = self.$shopNowUrl.val().split('\n');
      var offerCodeTxt = self.$element.data('offer-codes');
      var cmsOfferCodes = offerCodeTxt.split(',');
      var offerCode = self.gameFormatter.getWinningOffer().winningOffer.offer_code;
      var url = $.trim(shopNowUrls[cmsOfferCodes.indexOf(offerCode)]);

      return url;
    },

    populateTriesIndicator: function ($triesBlock) {
      var self = this;

      var $triesCont = $triesBlock.empty();
      var triesOnImg = $triesCont.attr('data-game-tries-marker-on');
      var triesOffImg = $triesCont.attr('data-game-tries-marker-spent');
      for (var i = 1; i <= self.maximumTries; i++) {
        var $container = $('<li class="game-turns__list__image"></li>');

        if (self.setTurnsRemaining() >= i) {
          $container.addClass('on').css('background-image', 'url(' + triesOnImg + ')');
        } else {
          $container.addClass('off').css('background-image', 'url(' + triesOffImg + ')');
        }
        $triesCont.append($container);
      }
      self.remainingTries();
      $triesBlock.append(self.$tries);
    },

    setTurnsRemaining: function () {
      var self = this;
      var getNumberOfTries = parseInt(self.gameFormatter.getNumberOfTries(), 10);

      return self.maximumTries - getNumberOfTries;
    },

    remainingTries: function () {
      var self = this;

      var pluralTriesText = self.$tries.data('plural-tries-left-text');
      var singularTriesText = self.$tries.data('singular-tries-left-text');
      var remainingTriesText = self.$tries.text().replace(/#|\d/, self.setTurnsRemaining());

      if (self.setTurnsRemaining() === 1) {
        remainingTriesText = self.setTurnsRemaining() + ' ' + singularTriesText;
      } else {
        remainingTriesText = self.setTurnsRemaining() + ' ' + pluralTriesText;
      }

      self.$tries.html(remainingTriesText);
    }
  };
})(jQuery, document, Drupal);
